import { render, staticRenderFns } from "./MonitoringFiles.vue?vue&type=template&id=2a1ec7ff&scoped=true&"
import script from "./MonitoringFiles.vue?vue&type=script&lang=js&"
export * from "./MonitoringFiles.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringFiles.vue?vue&type=style&index=0&id=2a1ec7ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1ec7ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
